import { useEffect, useState } from "react";
import { useGetReferralLinkQuery } from "../lib/api/apiSlice";


/**
 * Custom hook to fetch referral link using RTK Query
 * Follows the same pattern as other API hooks in the codebase
 * 
 * @returns {Object} Object containing referral link, loading state, and error
 */
export const useReferralLink = () => {
	// Always start with false to match SSR (no localStorage during SSR)
	const [hasToken, setHasToken] = useState(false);

	// Update token availability when token is stored (client-side only after hydration)
	useEffect(() => {
		const checkToken = () => {
			if (typeof window !== "undefined") {
				const token = localStorage.getItem("accessToken");
				setHasToken(!!token);
			}
		};

		// Check immediately on mount (client-side)
		checkToken();

		// Listen for token storage events
		if (typeof window !== "undefined") {
			window.addEventListener("tokenStored", checkToken);
			return () => {
				window.removeEventListener("tokenStored", checkToken);
			};
		}
	}, []);

	const { data, error, isLoading } = useGetReferralLinkQuery(undefined, {
		skip: !hasToken,
		refetchOnMountOrArgChange: false,
	});

	return {
		referralLink: data?.success && data.data?.referral_link ? data.data.referral_link : null,
		loading: isLoading,
		error: error ? (error as any).message || String(error) : null,
	};
};
